<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">(This edition is a reprint of the work first published by Tragic Circumstances, reputed to be circa 1975. Dated references in the prefaces, introduction and the novella itself have been unedited so that the work is presented in its original form.)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Reprint.vue?7de890d1